var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.6667 7.16732H1.33333M7.33333 9.83398H4M1.33333 5.96732L1.33333 11.034C1.33333 11.7807 1.33333 12.1541 1.47866 12.4393C1.60649 12.6902 1.81046 12.8942 2.06134 13.022C2.34656 13.1673 2.71993 13.1673 3.46667 13.1673L12.5333 13.1673C13.2801 13.1673 13.6534 13.1673 13.9387 13.022C14.1895 12.8942 14.3935 12.6902 14.5213 12.4393C14.6667 12.1541 14.6667 11.7807 14.6667 11.034V5.96732C14.6667 5.22058 14.6667 4.84721 14.5213 4.562C14.3935 4.31112 14.1895 4.10714 13.9387 3.97931C13.6534 3.83399 13.2801 3.83399 12.5333 3.83399L3.46667 3.83398C2.71993 3.83398 2.34656 3.83398 2.06134 3.97931C1.81046 4.10714 1.60649 4.31111 1.47866 4.562C1.33333 4.84721 1.33333 5.22058 1.33333 5.96732Z",
    stroke: "#5A27DD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.0e6c85a618e29e86cd897b5e1168ca62.svg";
export { ForwardRef as ReactComponent };